import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getMachinePriceStatistics,
  IGetMachinePriceStatisticsParams,
  machinePriceStatisticsApiUrl,
} from '../../../../api/marketPrice/queries/getMachinePriceStatistics';
import { IMarketPrice } from '../../../../interfaces/MarketPrice.interfaces';

interface IUseGetMachinePriceStatisticsQueryParams extends IGetMachinePriceStatisticsParams {
  options?: UseInfiniteQueryOptions<any[], AxiosError>;
}

export const useGetMachinePriceStatistics = ({ searchParam, options }: IUseGetMachinePriceStatisticsQueryParams) => {
  return useInfiniteQuery<IMarketPrice[], AxiosError>(
    [
      machinePriceStatisticsApiUrl,
      `brand=${searchParam?.brand}`,
      `minEngineOutputPs=${searchParam?.minEngineOutputPs}`,
      `maxEngineOutputPs=${searchParam?.maxEngineOutputPs}`,
      `minMedianPrice=${searchParam?.minMedianPrice}`,
      `maxMedianPrice=${searchParam?.maxMedianPrice}`,
      `sort=${searchParam?.sort}`,
      `count=${searchParam?.count}`,
    ],
    ({ pageParam = 1 }) => getMachinePriceStatistics({ searchParam: { ...searchParam, page: pageParam } }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage?.length === 0 || lastPage?.length < searchParam.count ? undefined : nextPage;
      },
    },
  );
};
